var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-content" } },
    [
      _vm.showWarning
        ? _c("app-launcher-warning-container")
        : _vm.showUpdateProgress
        ? _c("app-launcher-update-container")
        : _vm.showLauncherSettings
        ? [
            _c("app-launcher-links-container"),
            _vm._v(" "),
            _c("apps-integration-container"),
            _vm._v(" "),
            _c("app-launcher-settings-container"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }